import { render, staticRenderFns } from "./GiftListBoard.vue?vue&type=template&id=b49ea780&scoped=true&"
import script from "./GiftListBoard.vue?vue&type=script&lang=js&"
export * from "./GiftListBoard.vue?vue&type=script&lang=js&"
import style0 from "./GiftListBoard.vue?vue&type=style&index=0&id=b49ea780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49ea780",
  null
  
)

export default component.exports